var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"vueApp",attrs:{"id":"app"}},[_c('input',{attrs:{"id":"kfStatus","type":"hidden","value":"0"}}),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }